export default __webpack_public_path__ + "static/Recoleta-SemiBold-bef46304c97d087d7f39114dc483a421.woff";